import { useEffect, useMemo, useState } from "react";

import { useIntegration, useSaveIntegration, useImportIntegrationExcel } from "./useIntegration";
import { toast } from "react-toastify";

export function useIntegrationForm({ option, filters = [], elementId, baseObject, onClose }) {
	const isOpen = option === "crear" || option === "editar";
	const isEditMode = option === "editar";
	const modalTitle = useMemo(() => (isEditMode ? "Revisar Integración" : "Crear Integración"), [isEditMode]);

	const { mutate: saveIntegration, isLoading: isLoadingSave } = useSaveIntegration();

	const canLoadDetail = isEditMode && !!elementId;
	const { data: element, isLoading: isLoadingElement, isFetching: isFetchingElement } = useIntegration(elementId, canLoadDetail);

	const { mutate: importExcel, isLoading: isLoadingExcel } = useImportIntegrationExcel();

	const [formState, setFormState] = useState({ ...baseObject });
	const [formErrors, setFormErrors] = useState({});
	const [infoMessages, setInfoMessages] = useState([]);
	const [messageType, setMessageType] = useState("info");

	useEffect(() => {
		if (isEditMode && element) {
			setFormState((prev) => ({
				...prev,
				...element,
			}));
		}
	}, [isEditMode, element]);

	const validateForm = (_state) => {
		const next = {};
		return next;
	};

	const buildPayload = (state) => {
		return {
			id: isEditMode ? Number(elementId) : undefined,

			host: state.host?.trim() || "",
			company: state.company?.trim() || "",
			username: state.username?.trim() || "",
			password: state.password?.trim() || "",

			production_host: state.production_host?.trim() || "",
			production_company: state.production_company?.trim() || "",
			production_username: state.production_username?.trim() || "",
			production_password: state.production_password?.trim() || "",

			databases: state.databases || [],

			filters: filters,
		};
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		const nextErrors = validateForm(formState);

		setFormErrors(nextErrors);
		if (Object.keys(nextErrors).length) return;

		const payload = buildPayload(formState);

		saveIntegration(payload, {
			onSuccess: () => {
				toast.success(isEditMode ? "Integración actualizada" : "Integración creada");
				onClose();
			},
			onError: (error) => {
				toast.error(<div style={{ whiteSpace: "pre-line" }}>{error?.response?.data?.message || "Error al guardar la integración"}</div>);
			},
		});
	};

	const handleExcel = async (dbSelected, file) => {
		setInfoMessages([]);
		const payload = {
			integration_id: Number(element.integration_id),
			db_selected: dbSelected || null,
			file,
		};

		importExcel(payload, {
			onSuccess: () => {
				setMessageType("success");
				setInfoMessages(["Excel importado correctamente"]);
			},
			onError: (error) => {
				const errorDetail = error?.response?.data?.data || error?.response?.data?.message || "Error al importar Excel";
				setMessageType("error");
				setInfoMessages([String(errorDetail)]);
			},
		});
	};

	return {
		isOpen,
		isEditMode,
		modalTitle,
		isLoadingSave,
		isLoadingElement,
		isLoadingExcel,
		isFetchingElement,

		formState,
		setFormState,
		formErrors,
		setFormErrors,
		infoMessages,
		messageType,
		clearInfoMessages: () => setInfoMessages([]),

		handleSubmit,
		handleExcel,
	};
}
